import { useState } from 'react';
import CustomTable from '../../../components/CustomTable';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import useWallets from '../../../customhooks/wallets/useWallets';
import { useNavigate } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import TopupAccount from '../payments/TopupAccount';
import Dashboardcards from './dashboardcards/dashboardcards';
import EnablingFeature from '../../../components/EnablingFeature';
import { useTransactions } from '../../../customhooks/useTransactions';
import { WalletBalances } from '../../../components/walletbalances/WalletBalances';
import { MoneySendIcon, WalletAddIcon } from '../../../components/icons';
import { useUserProfile } from '../../../customhooks/useUserProfile';
import { LoadingCircles } from '../../../components/icons/LoadingCircles';
import { hasPermission } from '../../../components/dashboard/dashboardpage/utils';
import {
    formatDate,
    formatNumber,
    getTransactionStatus
} from '../../../utils/helper';
import Button from '../../../components/button/Button';
import { Tag } from 'antd';
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    ExclamationCircleOutlined,
    SyncOutlined
} from '@ant-design/icons';
import DashboardTableMobileCard from '../../../components/DashboardTableMobileCard';

const Dashboardmain = () => {
    const { wallets, isLoading: isLoadingWallets } = useWallets();
    const { isLoading: isLoadingUserProfile, permissions } = useUserProfile();

    const navigate = useNavigate();

    const state = useSelector((state: RootState) => ({
        user: state.user.user
    }));

    const { user } = state;

    const [showTopUp, setShowTopUp] = useState(false);

    const {
        isLoading: isTransactionsLoading,
        transactionsList,
        invalidateTransactionsCache: fetchTransactions
    } = useTransactions({ page: 0, size: 5 });

    const closeShowTopUp = () => {
        setShowTopUp(false);
    };

    const actions = [
        {
            display:
                permissions &&
                hasPermission({
                    userPermissions: permissions,
                    module: 'payments',
                    permissionList: ['write', '*']
                }),
            title: 'Add funds',
            icon: <WalletAddIcon />,
            onHandleClick: () => {
                setShowTopUp(true);
            }
        },
        {
            display:
                permissions &&
                hasPermission({
                    userPermissions: permissions,
                    module: 'payments',
                    permissionList: ['write', '*']
                }),
            title: 'Make payment  ',
            icon: <MoneySendIcon />,
            onHandleClick: () => {
                navigate('/payments/make-payment');
            }
        }
    ];

    const dashboardNav = [
        {
            text: 'Exchange currencies and send payments instantly',
            enablingFeature: 'Payments',
            actionText: 'Exchange currencies',
            onClick: () => navigate('/payments/make-payment'),
            className: 'bg-[#D0F8AB]'
        }
        // {
        //     text: 'Book and track all your shipments in one place',
        //     enablingFeature: 'BookingInttra',
        //     actionText: 'Book now',
        //     onClick: () => navigate('/bookings'),
        //     className: 'bg-[#FECDD6]'
        // },
        // {
        //     text: 'Get paid upfront on all your shipments.',
        //     enablingFeature: 'Financing',
        //     actionText: 'Get financed',
        //     onClick: () => navigate('/financing'),
        //     className: 'bg-[#FFD6AE]'
        // },
        // {
        //     text: 'Create and manage all trade documents in one place.',
        //     enablingFeature: 'TradeDocuments',
        //     actionText: 'Get started',
        //     onClick: () => navigate('/trade-documents'),
        //     className: 'bg-[#FEEE95]'
        // }
    ];

    return (
        <div>
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 1
                }}
                open={isLoadingUserProfile}
            >
                <div className='animate-spin'>
                    <LoadingCircles />
                </div>{' '}
            </Backdrop>

            <div className='flex justify-between mt-6 mb-4 px-4 lg:px-0'>
                <h1 className='text-[20px] font-medium text-gray200'>
                    Welcome,{' '}
                    {user?.first_name &&
                        ` ${user?.first_name} ${user?.last_name}.`}
                </h1>
            </div>
            <div className='px-4 lg:px-0'>
                <WalletBalances
                    wallets={wallets}
                    isLoading={isLoadingWallets}
                    actions={actions}
                />
            </div>
            <div className='flex gap-4 overflow-x-scroll max-w-[calc(100vw)] px-4 lg:px-0'>
                {dashboardNav?.map((item) => (
                    <EnablingFeature flag={item.enablingFeature}>
                        <Dashboardcards
                            text={item.text}
                            onClick={item.onClick}
                            actionText={item.actionText}
                            className={item.className}
                        />
                    </EnablingFeature>
                ))}
            </div>

            <div className='mt-8 '>
                <div className='bg-white lg:rounded-lg'>
                    <div className='flex justify-between w-full items-center p-4'>
                        <h3 className=' text-ebony text-[18px] font-semibold '>
                            Transactions
                        </h3>

                        <Button
                            variant='secondaryOutline'
                            text='View all'
                            onClick={() => navigate('/payments/transactions')}
                        />
                    </div>

                    <CustomTable
                        data={transactionsList ?? []}
                        loadingData={isTransactionsLoading}
                        columns={[
                            {
                                title: 'Status',
                                dataIndex: 'status',
                                key: 'status',
                                render: (_, { status }) => (
                                    <Tag
                                        bordered={false}
                                        color={
                                            getTransactionStatus(status) ===
                                            'Processing'
                                                ? 'processing'
                                                : getTransactionStatus(
                                                      status
                                                  ) === 'Completed'
                                                ? 'success'
                                                : getTransactionStatus(
                                                      status
                                                  ) === 'Initiated'
                                                ? 'warning'
                                                : 'error'
                                        }
                                        icon={
                                            getTransactionStatus(status) ===
                                            'Processing' ? (
                                                <SyncOutlined spin />
                                            ) : getTransactionStatus(status) ===
                                              'Completed' ? (
                                                <CheckCircleOutlined />
                                            ) : getTransactionStatus(status) ===
                                              'Initiated' ? (
                                                <ExclamationCircleOutlined />
                                            ) : (
                                                <CloseCircleOutlined />
                                            )
                                        }
                                    >
                                        {getTransactionStatus(status)}
                                    </Tag>
                                )
                            },
                            {
                                title: 'Date',
                                dataIndex: 'transactionStartDate',
                                key: 'transactionStartDate',
                                render: (_, { transactionStartDate }) => (
                                    <span>
                                        {formatDate(transactionStartDate)}
                                    </span>
                                )
                            },
                            {
                                title: 'Corporate',
                                dataIndex: 'businessName',
                                key: 'businessName'
                            },
                            {
                                title: 'Transaction ID',
                                dataIndex: 'transactionReference',
                                key: 'transactionReference',
                                render: (text, { transactionReference }) => (
                                    <span
                                        className='cursor-pointer text-appcolorprimary'
                                        onClick={() => {
                                            navigate(
                                                `/payments/transactions/${transactionReference}`
                                            );
                                        }}
                                    >
                                        {text}
                                    </span>
                                )
                            },
                            {
                                title: 'From',
                                dataIndex: 'amountFrom',
                                key: 'amountFrom',
                                render: (text, { fromCurrencyCode }) => (
                                    <span>
                                        {fromCurrencyCode}{' '}
                                        {formatNumber(parseFloat(text))}
                                    </span>
                                )
                            },
                            {
                                title: 'To',
                                dataIndex: 'amountTo',
                                key: 'amountTo',
                                render: (text, { toCurrencyCode }) => (
                                    <span>
                                        {toCurrencyCode}{' '}
                                        {formatNumber(parseFloat(text))}
                                    </span>
                                )
                            },
                            {
                                title: 'Rate',
                                dataIndex: 'rateValue',
                                key: 'rateValue',
                                render: (text) => (
                                    <span>{parseFloat(text).toFixed(5)}</span>
                                )
                            },
                            {
                                title: 'Type',
                                dataIndex: 'transactionAction',
                                key: 'transactionAction'
                            }
                        ]}
                        mobileComponent={<DashboardTableMobileCard />}
                    />
                </div>
            </div>

            <TopupAccount
                wallets={wallets}
                closeDrawer={closeShowTopUp}
                showDrawer={showTopUp}
                loadingWallets={isLoadingWallets}
            />
        </div>
    );
};

export default Dashboardmain;
